import React from 'react';
import classnames from 'classnames';
import { SearchEntity } from 'v2/models';
import styles from './RequestsItem.module.scss';
import { formatDate } from 'v2/utils/dateUtils';

interface RequestsItemProps {
  request: SearchEntity;
  onClick: (request: SearchEntity) => void;
  isSelected: boolean;
}

const RequestsItem = ({ request, onClick, isSelected }: RequestsItemProps) => {
  return (
    <div
      role="button"
      onClick={() => onClick(request)}
      className={classnames(styles.item, { [styles.itemSelected]: isSelected })}
    >
      <div className={classnames(styles.itemContainer)}>
        <p className={classnames(styles.requestsName)}>{request.name}</p>
        <p className={classnames(styles.requestsDate)}>
          {formatDate(request.created_at, false)}
        </p>
      </div>
    </div>
  );
};

export default RequestsItem;
